import { get } from 'lodash';

import { AnyFormValues, Asset } from '@funnels/types';
import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import getAssetPurpose from './getAssetPurpose';

export default function getRefinanceProperty(formValues: AnyFormValues): Asset | undefined {
  const assets: Asset[] = get(formValues, FIELD_PATHS.ASSETS(), []);

  return assets.find((_: Asset, index: number) => getAssetPurpose(formValues, index) === FIELD_VALUES.REFINANCE);
}
